import Skeleton from './index.vue'

Skeleton.install = (app) => {
  app.component(Skeleton.name, Skeleton)
}

export default Skeleton
